import { render, staticRenderFns } from "./top-menu.vue?vue&type=template&id=a6e4dc5a&"
import script from "./top-menu.vue?vue&type=script&lang=js&"
export * from "./top-menu.vue?vue&type=script&lang=js&"
import style0 from "./top-menu.vue?vue&type=style&index=0&id=a6e4dc5a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports